export const APP_ANDROID =
  "https://play.google.com/store/apps/details?id=com.momentoseguros";
export const APP_IOS =
  "https://apps.apple.com/mx/app/momento-seguros/id6449753093";
export const LANDING_PAGE = "https://www.tumomento.com/";
export const BLOG_PAGE = "https://blog.tumomento.com/";
export const API_URL = "https://api.tumomento.com/";
export const SETTINGS_CAROUSEL = {
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplaySpeed: 2000,
  autoplay: true,
  className: "w100",
};
export const FACEBOOK_MOMENTO = "https://www.facebook.com/momentoseguros/";
export const INSTAGRAM_MOMENTO = "https://www.instagram.com/momentosegurosmx/";
export const TWITTER_MOMENTO = "https://twitter.com/momento_seguros";
export const APPS_FOOTER_MOMENTO = [
  {
    linkText: "Descarga Momento en Google PlayStore",
    link: APP_ANDROID,
    image: `${LANDING_PAGE}/images/googleplay.webp`,
  },
  {
    linkText: "Descarga Momento en App Store",
    link: APP_IOS,
    image: `${LANDING_PAGE}/images/appstore.webp`,
  },
];

export const SOCIAL_MEDIA_FOOTER_MOMENTO = [
  {
    linkText: "Facebook Momento",
    link: FACEBOOK_MOMENTO,
    image: `${LANDING_PAGE}/images/facebook.svg`,
  },
  {
    linkText: "Instagram Momento",
    link: INSTAGRAM_MOMENTO,
    image: `${LANDING_PAGE}/images/instagram.svg`,
  },
];

export const PHONE_MOMENTO = "800 953 0690";
export const EMAIL_MOMENTO = "soporte@tumomento.com";
export const ADDRESS_MOMENTO =
  'Paseo de la Reforma 505, Piso 40, Suite "B", Colonia Cuauhtémoc, Alcaldía Cuauhtémoc, Código Postal 06500, Ciudad de México, México.';
export const ADDRESS_MOMENTO_HREF = "https://maps.app.goo.gl/CjzjsXkFw7YW6cEv7";
export const CuestionarioDeIdentificacionDelCliente =
  "/documents/CuestionarioDeIdentificacionDelCliente.pdf";
export const GuiaDeDeslinde = "/documents/GuiaDeDeslinde.pdf";

export const URL_ACCIDENTS = "/siniestros";
export const URL_APP = "/app";
export const URL_WHO = "/quienes-somos";
export const URL_AGENTS = "/agentes";

export const FOOTER_LINKS = [
  {
    title: "Contáctanos",
    links: [
      {
        color: "content2",
        linkText: PHONE_MOMENTO,
        link: `tel:+${PHONE_MOMENTO.replaceAll(" ", "")}`,
      },
      {
        color: "green3",
        linkText: EMAIL_MOMENTO,
        link: `mailto:${EMAIL_MOMENTO}`,
      },
      {
        color: "content2",
        linkText: ADDRESS_MOMENTO,
        link: ADDRESS_MOMENTO_HREF,
      },
    ],
  },
  {
    title: "Acerca de Momento",
    links: [
      {
        color: "green3",
        linkText: "Preguntas frecuentes",
        link: `${LANDING_PAGE}/preguntas-frecuentes`,
      },
      {
        color: "green3",
        linkText: "Manual de ajustadores",
        link: `${LANDING_PAGE}/documents/Momento%20Seguros%20-%20Manual%20de%20Ajustador.pdf`,
      },
    ],
  },
  {
    title: "Legales",
    links: [
      {
        color: "green3",
        linkText: "Aviso de privacidad",
        link: `${LANDING_PAGE}/aviso-de-privacidad`,
      },
      {
        color: "green3",
        linkText: "UNE Momento",
        link: `${LANDING_PAGE}/une-momento`,
      },
      {
        color: "green3",
        linkText: "Términos y condiciones",
        link: `${LANDING_PAGE}/terminos-y-condiciones`,
      },
      {
        color: "green3",
        linkText: "Condiciones generales",
        link: `${LANDING_PAGE}/condiciones-generales`,
      },
      {
        color: "green3",
        linkText: "Buró de entidades financieras",
        link: `${LANDING_PAGE}/buro-de-entidades-financieras`,
      },
      {
        color: "green3",
        linkText: "Información financiera",
        link: `${LANDING_PAGE}/informacion-financiera`,
      },
      {
        color: "green3",
        linkText: "Seguro básico estandarizado",
        link: `${LANDING_PAGE}/seguro-basico-estandarizado`,
      },
    ],
  },
  {
    title: "Otros documentos",
    links: [
      {
        color: "green3",
        linkText: "Guía de Deslinde ",
        link: `${LANDING_PAGE}/documents/GuiaDeDeslinde.pdf`,
      },
      {
        color: "green3",
        linkText: "Cuestionario de Identificación del Cliente",
        link: `${LANDING_PAGE}/documents/CuestionarioDeIdentificacionDelCliente.pdf`,
      },
    ],
    isBlank: true,
  },
];
